export default __webpack_public_path__ + "play.svg";